import { render, staticRenderFns } from "./QualityWhInventory.vue?vue&type=template&id=64681b59&scoped=true"
import script from "./QualityWhInventory.vue?vue&type=script&lang=js"
export * from "./QualityWhInventory.vue?vue&type=script&lang=js"
import style0 from "./QualityWhInventory.vue?vue&type=style&index=0&id=64681b59&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64681b59",
  null
  
)

export default component.exports